import React from 'react';

export default function Emphasize({ children, color = '#ff004e', bold = false }) {
    return <span style={{ color, fontWeight: bold ? 500 : 400 }}>{children}</span>;
}
